export default __webpack_public_path__ + "static/media/image1.1620f59f.png";